import React, { useState, useEffect } from "react";

import { withRouter, Link } from "react-router-dom";

import Layout from "../../components/Layout";

import {apiCRMv3} from "../../services/api";

import Swal from "sweetalert2";

const UsersConsortiumList = (props) => {
    const [users, setusers] = useState([]);
    const [usersToShow, setUsersToShow] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(function () {
        loadList();
    }, []);

    async function loadList() {
        setLoaded(false);

        const responseUsers = await apiCRMv3.get("/exclusive-consortium");
        setusers(responseUsers.data.data.users);
        setUsersToShow(responseUsers.data.data.users);
        setLoaded(true);
    }

    function handleSearchBar() {
        setLoaded(false);

        const originalUsers = users;

        if (searchText === "") {
            setUsersToShow(originalUsers);
            setLoaded(true);
            return;
        }

        let filteredUsers = originalUsers.filter(
            (users) =>
                users.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) !== -1
        );

        setUsersToShow(filteredUsers);
        setLoaded(true);
    }

    return (
        <Layout
            menuActive="registers"
            pageTitle="Lista de Usuários Consórcio"
            enableSearchBar={true}
            searchTerm={searchText}
            searchOnChange={(e) => setSearchText(e.target.value)}
            handleSearch={handleSearchBar}
        >
            <div className="row">
                <div className="col-xs-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">
                                Lista de Usuários Consórcio
                            </div>
                        </div>
                        <div
                            className={`card-body ${loaded ? "" : "__loading"}`}
                        >
                            <div className="loader-container text-center">
                                <div className="icon">
                                    <div className="sk-wave">
                                        <div className="sk-rect sk-rect1"></div>
                                        <div className="sk-rect sk-rect2"></div>
                                        <div className="sk-rect sk-rect3"></div>
                                        <div className="sk-rect sk-rect4"></div>
                                        <div className="sk-rect sk-rect5"></div>
                                    </div>
                                </div>
                                <div className="title">Carregando</div>
                            </div>

                            <div className="row">
                                <div className="col-xs-12">
                                    <table className="table table-striped table-bordered table-hover">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Filial</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {usersToShow.map(
                                                (user, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                {
                                                                    user.name
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    user.branch.longCode
                                                                }
                                                            </td>
                                                        </tr>
                                                    );
                                                }
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default withRouter(UsersConsortiumList);
